// Per-viewer conveniences (saved view, sort, expanded sections) in localStorage; never required for correctness.
import { useCallback, useState } from 'react';

export function readPref<T>(key: string, fallback: T): T {
  try {
    const raw = typeof localStorage === 'undefined' ? null : localStorage.getItem(`helm.pref.${key}`);
    return raw == null ? fallback : (JSON.parse(raw) as T);
  } catch { return fallback; }
}
export function writePref<T>(key: string, value: T): void {
  try { if (typeof localStorage !== 'undefined') localStorage.setItem(`helm.pref.${key}`, JSON.stringify(value)); } catch { /* private mode */ }
}
export function usePref<T>(key: string, fallback: T): [T, (v: T) => void] {
  const [v, setV] = useState<T>(() => readPref(key, fallback));
  const set = useCallback((n: T) => { setV(n); writePref(key, n); }, [key]);
  return [v, set];
}
